import {Vacature} from '../../models/vacature';
import {Component, input} from '@angular/core';
import {VacatureDetailComponent} from '../vacature-detail/vacature-detail.component';


@Component({
  selector: 'mvw-vacature-info',
  templateUrl: './vacature-info.component.html',
  imports: [VacatureDetailComponent]
})
export class VacatureInfoComponent {

  vacatures = input.required<Vacature[]>();

}
